import classNames from 'classnames';
import DebtFormChips from 'components/generics/forms/DebtForm/components/DebtFormChips';
import DebtFormConfirm from 'components/generics/forms/DebtForm/components/DebtFormConfirm';
import DebtFormInput from 'components/generics/forms/DebtForm/components/DebtFormInput';
import DebtFormSubtitle from 'components/generics/forms/DebtForm/components/DebtFormSubtitle';
import DebtFormTitle from 'components/generics/forms/DebtForm/components/DebtFormTitle';
import classes from 'components/generics/forms/DebtForm/index.module.scss';
import Typography from 'components/generics/texts/Typography';
import AnimateWhenVisible from 'components/transitions/AnimateWhenVisible';
import { INVEST_LEND_PRESSED } from 'consts/analytics/BuyFlowEvents';
import { OrderKind, OrderType } from 'consts/enums/order';
import { PLACE_ORDER_ROUTE } from 'consts/routes/urls';
import { analytics } from 'hooks/integrations/mixpanel/useMixpanel';
import { useLandaRouter } from 'hooks/logics/useLandaRouter';
import useStockPrice from 'hooks/requests/properties/useStockPrice';
import useAppSettings from 'hooks/requests/useAppSettings/useAppSettings';
import { DEBT_TICKER } from 'pages/lend/utils';
import React, { HTMLAttributes, useState } from 'react';
import { useCurrentPlaceOrderStore } from 'stores/CurrentPlaceOrder/currentPlaceOrder';
import DebtFormToggle from './components/DebtFormToggle';
import { DebtProvider, useDebt } from './context';
import DebtRedeemFormConfirm from './components/DebtRedeemFormConfirm';
import { useLandaApiQuery } from '../../../../hooks/api/graphql/landa_api';
import { GET_REDEMPTION_STATUS } from '../../../../graphql/orders/queries/GetRedemptionStatus';
import useUserDetails from '../../../../hooks/requests/user/hooks/useUserDetails';
import useAuth from '../../../../context/Auth';

const DebtForm = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <DebtProvider>
      <InnerDebtForm className={className} />
    </DebtProvider>
  );
};

const InnerDebtForm = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  const { [DEBT_TICKER]: price } = useStockPrice(DEBT_TICKER);
  const { isLoggedIn } = useAuth();
  const { data: redemptionData } = useLandaApiQuery(GET_REDEMPTION_STATUS, {
    variables: { ticker: DEBT_TICKER, amount: 1 },
    skip: !isLoggedIn,
  });
  const [amount, setAmount] = useState<number>();
  const { appSettings } = useAppSettings();
  const { orderKind } = useDebt();

  const aboveLimit = amount && amount >= appSettings.minimumDebtShareAmount;
  const moneyAmount = amount && price && amount * price;
  const setCurrentPurchase = useCurrentPlaceOrderStore(
    (state) => state.setCurrentPlaceOrder
  );
  const { navigate } = useLandaRouter();

  const { userDetails } = useUserDetails();
  // const { router } = useLandaRouter();
  // useEffect(() => {
  //   if (userDetails?.isTenant) {
  //     router.replace(FEED_ROUTE);
  //   }
  // }, [userDetails]);

  const goToOrderPage = () => {
    analytics.track(INVEST_LEND_PRESSED, {
      kind: orderKind,
      type: OrderType.LIMIT,
      ticker: DEBT_TICKER,
      amount,
      target_value: price,
    });
    amount &&
      setCurrentPurchase({
        ticker: DEBT_TICKER,
        amount,
        pricePerShare: price,
        kind: orderKind,
        type: OrderType.LIMIT,
        isDebt: true,
        limitPrice: price,
      });
    navigate(PLACE_ORDER_ROUTE);
  };
  const isRedemptionAvailable =
    !!redemptionData?.getRedemptionStatus?.redemptionSharesValidAmount;

  return (
    <AnimateWhenVisible className={classNames(classes.container, className)}>
      {isRedemptionAvailable && <DebtFormToggle />}
      <DebtFormTitle
        redemptionSharesValidAmount={
          redemptionData?.getRedemptionStatus?.redemptionSharesValidAmount
        }
      />
      {orderKind === OrderKind.BUY && <DebtFormSubtitle price={price} />}
      {/* <DebtFormInput // TEMPORARY STOP: hide input for BUY flow across all properties.
        amount={amount}
        setAmount={setAmount}
        redemptionSharesValidAmount={
          redemptionData?.getRedemptionStatus?.redemptionSharesValidAmount
        }
      /> */}
      <Typography className={classes.minimum}>
        {orderKind === OrderKind.BUY &&
          !!amount &&
          !aboveLimit &&
          `${appSettings.minimumDebtShareAmount} shares minimum ($${appSettings.minimumDebtPrice})`}
      </Typography>
      {orderKind !== OrderKind.BUY && (
        <Typography className={classes.minimum}>
          {redemptionData?.getRedemptionStatus?.redemptionSharesValidAmount}{' '}
          shares available for redemption
        </Typography>
      )}
      {/* {orderKind === OrderKind.BUY && ( // TEMPORARY STOP: hide preset chips for BUY flow across all properties.
        <>
          <Typography className={classes.orSelect}>Or select</Typography>
          <DebtFormChips
            setAmount={setAmount}
            amount={amount}
            className={classes.chips}
          />
        </>
      )} */}
      {orderKind === OrderKind.BUY && (
        <DebtFormConfirm
          onConfirm={goToOrderPage}
          moneyAmount={moneyAmount}
          disabled={true}
          // disabled={!appSettings || !moneyAmount || !aboveLimit} // TEMPORARY STOP: hide input for BUY flow across all properties.
        />
      )}
      {orderKind === OrderKind.SELL && (
        <DebtRedeemFormConfirm
          onConfirm={goToOrderPage}
          amount={amount}
          redemptionSharesValidAmount={
            redemptionData?.getRedemptionStatus?.redemptionSharesValidAmount
          }
        />
      )}
    </AnimateWhenVisible>
  );
};

export default DebtForm;
